import type { RouteRecordRaw } from 'vue-router'

import AppPanelLayout from '@/core/layouts/AppPanelLayout.vue'
import { authRoute } from '@/features/auth/routes'
import { companySettingsRoute, selectCompanyRoute } from '@/features/companies/routes'
import { inventoryItemsRoute } from '@/features/inventory-items/routes'
import { salesRoute } from '@/features/sales/routes'
import { plansRoute } from '@/features/plans/routes'

export const routes: Array<RouteRecordRaw> = [
  {
    path: '/:pathMatch(.*)*',
    redirect: { name: 'login' },
  },
  {
    name: 'app-rb-empresas',
    path: '/',
    component: AppPanelLayout,
    redirect: { name: 'inicio' },
    meta: { requiresAuth: true },
    children: [
      {
        name: 'inicio',
        path: 'inicio',
        component: () => import('@/core/pages/DashboardPage.vue'),
      },
      salesRoute,
      {
        name: 'faturamento',
        path: 'faturamento',
        redirect: { name: 'meu-dinheiro' },
        children: [
          {
            name: 'meu-dinheiro',
            path: 'meu-dinheiro',
            component: () => import('../../pages/wallet/balance/Balance.vue'),
          },
          {
            name: 'extrato',
            path: 'extrato',
            component: () => import('../../pages/wallet/extracts/Extracts.vue'),
          },
          {
            name: 'transferencias',
            path: 'transferencias',
            component: () => import('../../pages/wallet/transfers/Transfers.vue'),
          },
        ],
      },
      companySettingsRoute,
      inventoryItemsRoute,
      plansRoute,
    ],
  },
  selectCompanyRoute,
  authRoute,
  {
    name: '404',
    path: '/404',
    component: () => import('../../pages/404.vue'),
  },
]
